
import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {

    constructor() {
    }
    // tenant dev
    //tenant prod c1eb5112-7946-4c9d-bc57-40040cfe3a91
    public get AdalConfig(): any {
        return {
            tenant: 'c1eb5112-7946-4c9d-bc57-40040cfe3a91',
            
            clientId: '37824aae-783f-40f7-8398-62c375895d65',
            extraQueryParameter: 'nux=1',

            redirectUri: window.location.origin + '/',

            postLogoutRedirectUri: window.location.origin + '/'
        };
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/_services/config.service.ts